export default "__VITE_ASSET__$iDcTt2n__"